<template>
  <div class="cliente-main-apartado"  v-if="arrayArticulos.length > 0">
    <div class="d-flex w-100 pr-3">
      <div class="cliente-main-apartado-titulo float-left">Lista de deseos</div>
        <v-select
						:items="wishLists"
						item-text="nombre"
						placeholder="Tipo"
            class="pt-0 mt-0"
						v-model="wishListSelected"
						attach
            dense
            return-object
						@change="cambiarWishList" />
    </div>
    <div class="apartado-slider">
      <splide
        :options="options"
        :slides="arrayArticulos"
      >
        <splide-slide v-for="articulo in arrayArticulos" :key="articulo.id">
          <cliente-articulo :producto="articulo"/>
        </splide-slide>
      </splide>
    </div>
  </div>
</template>
<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import ClienteArticulo from './ClienteArticulo.vue'
import { ClienteApiService } from '@/api/ClienteApiService';
const clienteApiService = new ClienteApiService()

export default {
  name: 'clienteRecomendados',
  components: {
    ClienteArticulo, Splide, SplideSlide
  },
  data() {
    return {
       options: {
        rewind: false,
        gap   : '2px',
        fixedWidth : '200px',
        arrows: true,
        pagination: false
      },
      arrayArticulos: [],
      wishLists: [],
      wishListSelected: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getAllWishLists()
    },
    getArticulosByWishList(wishlist) {
      clienteApiService.getArticulosByWishList(wishlist)
        .then(data => {
          this.arrayArticulos = data
        })
        .catch(error => {
          console.log (error)
        })
    },
    getAllWishLists() {
      clienteApiService.getAllWishLists(this.$store.getters.getCliente.id)
        .then(data => {
          this.wishLists = data
          this.getArticulosByWishList(data[0])
          this.wishListSelected = data[0]
        })
        .catch(error => {
          console.log (error)
        })
    },
    cambiarWishList() {
      this.getArticulosByWishList(this.wishListSelected)
    }
  },
}
</script>
<style scoped>
.cliente-main-apartado >>> .v-select__selections input { 
  display: none;
}
</style>